module.exports = __webpack_public_path__ + "h5/img/logo.850692e0.png";